<template>
  <div
    v-if="value"
    :class="{
      'popup-wrp': true,
      'is-android': $platform.isAndroid
    }"
    ref="wrapper"
  >
    <div
      class="popup-mask zixun-global-center"
      ref="mask"
      @touchmove.stop.prevent
    >
      <transition name="zoom" @enter="onPosterAnimateEnd">
        <div
          v-if="posterUrl"
          class="popup-content"
          :class="{
            qingsu: showQingsuPoster,
            pt: !isConsultTeacher && !isQingtingTeacher
          }"
          ref="content"
        >
          <div class="content-tip">
            <p class="tip-text">长按卡片可保存到相册</p>
            <p class="icon-wrp">
              <i class="icon icon-node-website icon-slide-up"></i>
            </p>
          </div>

          <div
            class="main-normal"
            :class="{
              qingsu: showQingsuPoster,
              pt: !isConsultTeacher && !isQingtingTeacher
            }"
          >
            <img class="poster-img" :src="posterUrl" alt="" />
          </div>

          <div
            class="content-button"
            @click="share"
            v-if="isCanShowShareBtn"
            :class="{ qingsu: showQingsuPoster }"
          >
            分享给好友
          </div>
          <div class="popup-close" @click="close">
            <i class="icon icon-node-website icon-guanbidanchuang"></i>
          </div>
        </div>
      </transition>
    </div>

    <div class="poster-container">
      <!-- 倾听师海报 -->
      <div
        v-if="showQingsuPoster"
        :key="200"
        ref="contentMain"
        class="qingsu-main qingsu-content"
      >
        <img
          class="qingsu-share-bg"
          crossOrigin="anonymous"
          src="~images/platform/homepage/qingsu-share-poster.png"
          alt=""
        />
        <div class="teacher-info">
          <div class="base-info">
            <div class="base-left">
              <div class="avatar">
                <img
                  ref="avatar"
                  :src="pageData.avatar | imgZip(102, 102)"
                  alt=""
                />
              </div>
              <div v-if="qingsuLevel">
                <img
                  class="teacher-level"
                  :src="
                    require(`images/platform/homepage/qingsu-poster-level-${qingsuLevel}.png`)
                  "
                  alt="等级"
                />
              </div>
            </div>
            <div class="base-right">
              <p class="m-name">{{ pageData.nickname }}</p>
              <div v-if="qualification" class="m-honor" ref="honor">
                <p>{{ qualification }}</p>
              </div>
            </div>
          </div>
          <div class="block-info">
            <div
              class="block"
              v-for="(item, index) in qingsuBlock"
              :key="index"
            >
              <div class="block-top DharmaTypeBebasKai">
                <p v-html="item.label"></p>
              </div>
              <div class="block-bottom" v-html="item.name"></div>
            </div>
          </div>
          <div class="tag-info">
            <p class="m-title">擅长领域</p>
            <ul>
              <li v-for="(tag, index) in expertise" :key="index">
                {{ tag }}
              </li>
            </ul>
          </div>
        </div>
        <div class="text-info">
          <p class="m-title">倾诉寄语</p>
          <div class="base-text" ref="title">
            <p>{{ pageData.brief }}</p>
          </div>
        </div>
        <div class="qrcode-wrp">
          <div class="qrcode-inner">
            <img crossOrigin="anonymous" :src="qrCodeBase64" />
          </div>
          <div class="qrcode-tip">扫码预约</div>
          <div class="logo-box">
            <img
              src="~images/platform/homepage/qingsu-poster-logo.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <!-- 咨询师海报DOM -->
      <div
        v-else-if="isConsultTeacher"
        class="main-normal content-main"
        ref="contentMain"
        :key="200"
      >
        <img
          class="zx-share-bg"
          crossOrigin="anonymous"
          src="~images/platform/homepage/zx-share-poster.png"
          alt=""
        />
        <div class="teacher-info">
          <div class="base-info">
            <div class="base-left">
              <div class="avatar">
                <img
                  ref="avatar"
                  :src="pageData.avatar | imgZip(102, 102)"
                  alt=""
                />
              </div>
              <div class="m-type" v-if="settingTag">
                <p>{{ settingTag }}</p>
              </div>
            </div>
            <div class="base-right">
              <p class="m-name">{{ pageData.nickname }}</p>
              <div class="m-honor" ref="honor">
                <p>{{ pageData.honor }}</p>
              </div>
            </div>
          </div>
          <div class="block-info">
            <div class="item" v-for="item in blockList" :key="item.id">
              <p class="item-top" v-html="item.value"></p>
              <p class="item-bottom">{{ item.text }}</p>
            </div>
          </div>
          <div class="tag-info">
            <p class="m-title">擅长领域</p>
            <ul>
              <li v-for="(tag, index) in tagList" :key="index">
                {{ tag }}
              </li>
            </ul>
          </div>
          <div class="text-info">
            <p class="m-title">咨询寄语</p>
            <div class="base-text" ref="title">
              <p>{{ pageData.brief }}</p>
            </div>
          </div>
        </div>
        <div class="qrcode-wrp">
          <div class="qrcode-inner">
            <img crossOrigin="anonymous" :src="qrCodeBase64" alt="" />
          </div>
          <div class="qrcode-tip">扫码预约我</div>
        </div>
        <div class="logo-box">
          <img
            class="logo-icon"
            src="~images/platform/homepage/logo.png"
            alt=""
          />
        </div>
      </div>

      <!-- 普通用户海报DOM -->
      <div ref="contentMain" class="user-poster-canvas" :key="200" v-else>
        <img
          class="poster-logo"
          src="~images/platform/homepage/poster-logo.png"
          alt="壹心理"
        />
        <div class="user-poster-canvas-main">
          <div class="user-poster-cover-box">
            <div class="user-poster-cover">
              <img
                ref="avatar"
                :src="pageData.avatar | imgZip(102, 102)"
                alt=""
              />
            </div>
            <img
              v-if="pageData.identities.length"
              class="user-poster-glory"
              src="~images/platform/homepage/glory.png"
              alt="鲸鱼尾巴标签"
            />
          </div>
          <div class="user-poster-info">
            <strong class="user-poster-name">{{ qrNicknameEllipsis }}</strong>
            <p class="user-poster-sign" v-if="pageData.identities.length">
              {{ qrUserIdentity }}
            </p>
          </div>
          <div class="user-poster-date">
            <div>
              <span class="active">
                <span class="active-number">{{
                  blocks.influence_num || 0
                }}</span>
              </span>
              <span class="active-text">浪花值</span>
            </div>
            <div>
              <span class="active">
                <span class="active-number">{{ blocks.fans_num || 0 }}</span>
              </span>
              <span class="active-text">粉丝</span>
            </div>
            <div>
              <span class="active">
                <span class="active-number">{{ blocks.follow_num || 0 }}</span>
              </span>
              <span class="active-text">关注</span>
            </div>
            <div>
              <span class="active">
                <span class="active-number">{{ blocks.praise_num || 0 }}</span>
              </span>
              <span class="active-text">获赞</span>
            </div>
            <div>
              <span class="active">
                <span class="active-number">{{ blocks.study_score || 0 }}</span>
              </span>
              <span class="active-text platform">鲸选学分</span>
            </div>
          </div>
          <div class="user-poster-qrcode">
            <p>扫码关注我，有时治愈，常常帮助，总是安慰。</p>
            <img crossOrigin="anonymous" :src="qrCodeBase64" alt="二维码" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { whichAnimationEnd } from 'utils/domUtil.js'
import { teacherShare } from 'api/consult'
import axios from 'axios'
import { isIOS9 } from 'app/frontend-lib/tools/getPlatform.js'
import { versionfunegt } from 'app/frontend-lib/tools/utils.js'
import { genCustomFonts } from 'utils/homepageUtil.js'

const prefixWWW = 'https://www.xinli001.com'
let html2canvas = null
function getBase64Image(img) {
  var canvas = document.createElement('canvas')
  canvas.width = img.width
  canvas.height = img.height
  console.log(canvas.width, canvas.height)
  var ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0, img.width, img.height)
  return canvas.toDataURL('image/jpeg')
}

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

export default {
  data() {
    return {
      posterUrl: '',
      qrCodeBase64: ''
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    pageData: {
      type: [Object, Array],
      required: true
    },
    qrCode: String,
    copyLinkUrl: String
  },
  computed: {
    // 当前url访问的是否咨询师
    isConsultTeacher() {
      return this.$store.getters['homepage/isConsultTeacher']
    },
    isQingtingTeacher() {
      return this.$store.getters['homepage/isQingtingTeacher']
    },
    teacherId() {
      return this.$route.params.userId
    },
    settingTag() {
      const tags = this.pageData.consult_identities || []
      return tags.length > 0 && tags[0].title ? tags[0].title : ''
    },
    tagList() {
      const list = this.pageData?.content?.expertise || []
      return list.map(v => v.category)
    },
    blockList() {
      const { consult_num, experience_year } = this.pageData.achieve_count
      let list = [
        {
          id: 1,
          value: `<span class="number">${consult_num}</span><span class="block-text fake">人数</span>`,
          text: '咨询人数'
        }
      ]

      if (isObject(experience_year)) {
        const arr = []
        if (+experience_year.year) {
          arr.push(
            `<span class="number">${experience_year.year}</span>
            <span class="block-text">年</span>`
          )
        }
        if (+experience_year.month) {
          arr.push(
            `<span class="number">${experience_year.month}</span>
            <span class="block-text">个月</span>`
          )
        }
        arr.length &&
          list.push({
            id: 2,
            value: arr.join(''),
            text: '从业年限'
          })
      }

      if (this.pageData.address) {
        list.push({
          id: 3,
          value: `<span class="number fake">${experience_year}</span><span class="block-text">${this.pageData.address}</span>`,
          text: '地区'
        })
      }

      return list
    },
    isCanShowShareBtn() {
      const {
        isYixinliApp,
        isZiXunApp,
        zixunAppVersion,
        isZiXunShiApp
      } = this.$platform
      return (
        isYixinliApp ||
        isZiXunShiApp ||
        (isZiXunApp && versionfunegt(zixunAppVersion, '4.1.0'))
      )
    },
    qrNicknameEllipsis() {
      if (this.isConsultTeacher) return
      const nickname = this.pageData.nickname
      if (nickname.length > 12) {
        return nickname.slice(0, 12) + '……'
      } else {
        return nickname
      }
    },
    qrUserIdentity() {
      if (this.isConsultTeacher) return
      return this.pageData.identities.reduce((str, item) => {
        return `${str}  ${item.name}`
      }, '')
    },
    blocks() {
      return this.pageData?.achieve_count
    },
    qingsuBlock() {
      const { qing_info = {} } = this.pageData
      const { qingnum, service_duration, goodrate, quick_rate } = qing_info
      return [
        {
          name: `倾诉人数`,
          get label() {
            return genCustomFonts(qingnum) + `<span class="bb-text">人</span>`
          }
        },
        {
          name: `倾诉时长`,
          get label() {
            return (
              genCustomFonts(service_duration) +
              `<span class="bb-text">小时</span>`
            )
          }
        },
        {
          name: `好评率`,
          get label() {
            const rate = Number(goodrate || 0).toFixed(1)
            return genCustomFonts(+rate) + `<span class="bb-text">%</span>`
          }
        },
        {
          name: `快速响应率`,
          get label() {
            return genCustomFonts(quick_rate) + `<span class="bb-text">%</span>`
          }
        }
      ]
    },
    qingsuLevel() {
      const { qing_info } = this.pageData
      if (qing_info && qing_info.grade) {
        return qing_info.grade.grade_level || ''
      }
      return ''
    },
    qualification() {
      const { qingsuServiceInfo } = this.pageData
      return qingsuServiceInfo.qualification || ''
    },
    expertise() {
      const { categorys } = this.pageData.qingsuServiceInfo || {}
      return categorys || []
    },
    currentTab() {
      return this.$store.state.homepage.currentTab
    },
    commonRateType() {
      return this.$store.state.homepage.commonRateType
    },
    showQingsuPoster() {
      return (
        (this.isQingtingTeacher && !this.isConsultTeacher) ||
        (this.isQingtingTeacher && this.currentTab.name === 'qingsu') ||
        (this.isQingtingTeacher &&
          this.currentTab.name === 'evaluate' &&
          this.commonRateType === 'qingsu')
      )
    }
  },
  async mounted() {
    this.posterUrlMap = {}
    this.$watch(
      () => this.value,
      val => {
        let cacheKey = ''
        if (this.showQingsuPoster) {
          cacheKey = 'qingsu'
        } else if (this.isConsultTeacher) {
          cacheKey = 'consult'
        } else {
          cacheKey = 'normal'
        }
        this.cachePosterUrl = this.posterUrlMap[cacheKey]
        if (val && this.cachePosterUrl) {
          this.posterUrl = this.cachePosterUrl
        } else if (val) {
          this.renderImage()
        } else {
          // 再次进入重新赋值posterurl，触发动画
          this.posterUrlMap[cacheKey] = this.posterUrl
          this.posterUrl = ''
        }
      }
    )
  },
  methods: {
    onPosterAnimateEnd() {
      // 弹窗够放不滚动就垂直居中，否则设置margin-top
      const { mask, content } = this.$refs
      if (window.innerHeight <= content.offsetHeight) {
        mask.classList.remove('zixun-global-center')
        content.classList.add('zixun-global-mt-40')
      }
    },
    loadImage(src) {
      return new Promise((resolve, reject) => {
        // 等二维码加载完毕后再生成海报
        const img = new Image()
        img.setAttribute('crossOrigin', 'Anonymous')
        if (img.complete && img.naturalWidth > 0) {
          sessionStorage.setItem('ljc_test_poster', '图片加载完毕')
          resolve(img)
        } else {
          img.onload = () => {
            sessionStorage.setItem('ljc_test_poster', 'img loaded!')
            resolve(img)
          }
          img.onerror = () => {
            sessionStorage.setItem('ljc_test_poster', 'img load error!')
            reject()
          }
        }
        img.src = src
      })
    },
    setTextContentEllipsis() {
      // 超过两行显示省略号
      const { honor, title } = this.$refs
      if (!honor && !title) return
      const array = [honor, title]
      array.forEach(el => {
        const child = el.children[0]
        // 反复尝试删除文本的最后一个单词，直到达到所需的大小
        while (child.offsetHeight > el.offsetHeight) {
          child.textContent = child.textContent.replace(
            /(\s)*([a-zA-Z0-9]+|\W)(\.\.\.)?$/,
            '...'
          )
        }
      })
    },

    /**
     * 1.html2canvas 不支持css object-fit cover
     * 2. 部分老师的头像是老的oss bucket 不支持压缩参数
     * 所以需要js判断下
     */
    setAvatarCenter() {
      return new Promise(resolve => {
        const { avatar } = this.$refs
        avatar.onload = () => {
          const { width, height } = avatar
          avatar.style.cssText =
            width > height
              ? 'height: 100%;width: auto;'
              : 'height: auto;width: 100%;'
          resolve()
        }
        avatar.onerror = resolve
      })
    },
    // 修复二维码图片在弱网环境下空白
    loadQrcode() {
      if (isIOS9()) {
        this.qrCodeBase64 = this.qrCode
        return Promise.resolve()
      }
      return this.loadImage(this.qrCode).then(img => {
        const qrCodeBase64 = getBase64Image(img)
        this.qrCodeBase64 = qrCodeBase64
      })
    },
    async renderImage() {
      const loading = this.$loading()
      try {
        await this.$nextTick()
        this.setTextContentEllipsis()
        await Promise.all([this.loadQrcode(), this.setAvatarCenter()])
        html2canvas = require('html2canvas')
        const _config = {
          useCORS: true,
          logging: false,
          scale: 2,
          backgroundColor: '#8c8df7',
          scrollY: 0 //解决有滚动条时滑动屏幕导致的图片不完整
        }

        // 看不见的dom来作为生成海报的容器
        const canvas = await html2canvas(this.$refs['contentMain'], _config)
        let src = canvas.toDataURL('image/jpeg') // 生成png oss参数不支持，体积也相对比较大
        loading.close()
        this.posterUrl = src
        this.$emit('uploadSuccess', this.posterUrl)

        // 悄悄上传，也是为了部分老一点的安卓无法支持base64长按保存
        if (this.isCanShowShareBtn) {
          let _url
          this.uploadingImagePromise = this.uploadImage(src)
            .then(url => {
              _url = url
              return this.loadImage(url)
            })
            .then(() => {
              this.posterUrl = _url
              this.$emit('uploadSuccess', this.posterUrl)
            })
        }
      } catch (e) {
        console.log(e)
        loading.close()
        this.$toast({
          text: '生成海报失败',
          callback: () => this.close()
        })
      }
    },
    uploadImage(src) {
      return new Promise((resolve, reject) => {
        return axios
          .post(
            prefixWWW + '/ajax/ueditor.json?action=uploadimage&type=base64',
            {
              upfile: src,
              type: 'base64'
            },
            {
              timeout: 1000 * 5,
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(res => {
            if (res.url) {
              resolve(res.url)
            } else {
              reject(res)
            }
          })
          .catch(reject)
      })
    },
    close() {
      this.$emit('input', false)
    },
    async share() {
      const loading = this.$loading()
      try {
        await this.uploadingImagePromise
        loading.close()
        let config = {
          imgUrl: this.posterUrl,
          // isHideSaveImage: 0,
          isHideCopy: 1,
          shareType: 'shareImage',
          success: () => teacherShare({ teacher_id: this.teacherId })
        }
        if (this.copyLinkUrl) {
          config.isHideCopy = 0
          config.link = this.copyLinkUrl
        }
        // 咨询师之家下会叠加两张海报，关闭前端这张
        if (this.$platform.isZiXunShiApp) {
          this.$emit('input', false)
        }

        config.isHideSendToChat = 1

        this.$bridge.shareReport(config)
      } catch (e) {
        loading.close()
        this.$toast({
          text: '分享失败, 请检查网络'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.zixun-global-center {
  align-items: center !important;
}
.zixun-global-mt-40 {
  margin-top: 40px !important;
}
</style>

<style lang="scss" scoped>
.zoom-enter-active,
.zoom-leave-active {
  transition: transform 0.3s, opacity 0.3s;
  transform: scale(1);
  opacity: 1;
}
.zoom-enter,
.zoom-leave-to {
  transform: scale(0);
  opacity: 0;
}

// 安卓生成海报时，文字会向下偏移2px，所以做了一个看不见的dom来作为生成海报的容器
.poster-container {
  opacity: 0;
  z-index: -1;
  position: fixed;
  width: 750px;
}
.is-android .poster-container {
  ::v-deep .block-text,
  .item-bottom {
    transform: translateY(-2px);
  }
}

.popup-wrp {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: $dialogZIndex;
  .popup-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    overflow: auto;
    display: flex;
    justify-content: center;
  }
  .popup-content {
    width: 600px;
    height: 1240px; // 内容超过屏幕会生成滚动
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    &.pt {
      width: 630px;
      height: 1240px;
      border-radius: 10px;
    }
    &.qingsu {
      width: 600px;
      height: auto;
    }
  }
  .content-tip {
    text-align: center;
    position: absolute;
    top: 0;
    width: 100%;
    left: 0;
    .tip-text {
      font-family: PingFangSC-Medium;
      font-size: 28px;
      color: #ffffff;
    }
    .icon-wrp {
      transform: rotate(180deg);
      i {
        color: #fff;
        font-size: 28px;
      }
    }
  }
  .main-normal {
    width: 600px;
    height: 1000px;
    margin: 88px 0 30px 0;
    border-radius: 10px;
    box-sizing: border-box;
    &.pt {
      width: 630px;
      border-radius: 10px;
      overflow: hidden;
    }
    &.qingsu {
      width: 600px;
      height: 1067px;
      border-radius: 10px;
    }
    .poster-img {
      width: 100%;
      height: 100%;
      border-radius: 10px;
      object-fit: cover;
    }
  }
  .content-main {
    position: relative;
    .zx-share-bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
    }
    .teacher-info {
      width: 540px;
      height: 740px;
      border-radius: 20px;
      padding: 30px;
      box-sizing: border-box;
      position: relative;
      margin-bottom: 24px;
      position: absolute;
      left: 30px;
      top: 40px;
      box-sizing: border-box;
      // padding-top: 52px;
      .base-info {
        margin-bottom: 28px;
        display: flex;
        .base-left {
          width: 102px;
          height: 102px;
          position: relative;
          margin-right: 30px;
          .avatar {
            border-radius: 50%;
            overflow: hidden;
            width: 100%;
            height: 100%;
            position: relative;
          }
          img {
            width: 100%;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            // height: 100%;
            // object-fit: cover;
          }
          .m-type {
            position: absolute;
            left: 50%;
            transform: translate(-50%, 0);
            bottom: -10px;
            background-image: linear-gradient(98deg, #ffecb4 1%, #ffdea2 100%);
            border-radius: 8px;
            white-space: nowrap;
            font-family: PingFangSC-Regular;
            color: #844200;
            text-align: center;
            width: auto;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            p {
              font-size: 24px;
              transform: scale(0.75); // 缩成18px
            }
          }
        }
        .base-right {
          flex: 1;
          .m-name {
            font-family: PingFangSC-Medium;
            font-size: 36px;
            color: #21252d;
            margin-bottom: 4px;
          }
          .m-honor {
            font-family: PingFangSC-Regular;
            font-size: 22px;
            color: #6d7588;
            text-align: justify;
            // 显示2行所需的高度
            height: 68px;
            // 超出2行显示省略号（html2canvas不支持）
            overflow: hidden;
            // display: -webkit-box;
            // -webkit-line-clamp: 2;
            // -webkit-box-orient: vertical;
            // text-overflow: ellipsis;
          }
        }
      }
      .block-info {
        background: #f5f7ff;
        border-radius: 10px;
        // padding: 0 40px;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        .item {
          text-align: center;
          // width: 96px;
          flex: 1;
          height: 84px;
          .item-top {
            // margin-bottom: 10px;
            font-size: 30px;
            color: #21252d;
            display: flex;
            align-items: baseline;
            justify-content: center;
            height: 48px;
            white-space: nowrap;
            // border: 1px solid red;
            box-sizing: border-box;
            ::v-deep .number {
              font-size: 34px;
              display: inline-block;
              line-height: 1;
              // background-color: pink;
            }
            ::v-deep .block-text {
              display: inline-block;
              line-height: 1;
              // background-color: rgb(155, 194, 163);
            }
            ::v-deep .fake {
              width: 0 !important;
              opacity: 0 !important;
            }
          }
          .item-bottom {
            font-family: PingFangSC-Regular;
            font-size: 22px;
            color: #6d7588;
            white-space: nowrap;
          }
        }
      }
      .m-title {
        font-family: PingFangSC-Medium;
        font-size: 28px;
        color: #21252d;
        text-align: justify;
      }
      .tag-info {
        margin-bottom: 28px;
        ul {
          font-size: 0;
          white-space: nowrap;
          padding: 28px 0;
          li {
            width: 140px;
            height: 54px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #6982fa;
            border-radius: 27px;
            margin-right: 30px;
            font-family: PingFangSC-Regular;
            font-size: 22px;
            color: #6982fa;
            text-align: justify;
            box-sizing: border-box;
            white-space: nowrap;
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
      .text-info {
        .base-text {
          margin-top: 16px;
          font-family: PingFangSC-Regular;
          font-size: 22px;
          color: #6d7588;
          text-align: justify;
          line-height: 36px;
          // 显示2行所需的高度
          height: 72px;
          // 超出2行显示省略号（html2canvas不支持）
          overflow: hidden;
          // display: -webkit-box;
          // -webkit-line-clamp: 2;
          // -webkit-box-orient: vertical;
          // text-overflow: ellipsis;
        }
      }
    }
    .qrcode-wrp {
      width: 130px;
      height: 160px;
      background: #ffffff;
      border-radius: 10px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 10px;
      position: absolute;
      box-sizing: border-box;
      left: 50%;
      transform: translateX(-50%);
      bottom: 90px;
      .qrcode-inner {
        width: 110px;
        height: 110px;
        margin-bottom: 4px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .qrcode-tip {
        font-family: PingFangSC-Regular;
        font-size: 20px;
        color: #21252d;
        text-align: center;
        white-space: nowrap;
      }
    }
    .logo-box {
      width: 100px;
      height: 24px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 45px;
      .logo-icon {
        width: 100px;
        height: 24px;
      }
    }
  }
  .content-button {
    width: 300px;
    height: 88px;
    background: #6982fa;
    border-radius: 44px;
    font-family: PingFangSC-Medium;
    font-size: 30px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    &.qingsu {
      width: 240px;
      height: 70px;
      font-size: 24px;
      font-weight: 500;
      background: #ff745b;
      border-radius: 35px;
    }
  }
  .popup-close {
    position: absolute;
    top: 12px;
    right: 0;
    .icon-guanbidanchuang {
      display: inline-block;
      width: 48px;
      height: 48px;
      background: url('~images/platform/homepage/bar_close.png') no-repeat
        center/100% 100%;
    }
    i {
      color: #fff;
      font-size: 48px;
    }
  }
}

.user-poster-canvas {
  background: url('~images/platform/homepage/poster-background.png') no-repeat
    center;
  background-size: 100% 100%;
  width: 630px;
  height: 952px;
  border-radius: 10px;
  padding: 0 40px;
  position: absolute;
  top: -100%;
  box-sizing: border-box;
  .poster-logo {
    width: 126px;
    position: absolute;
    top: 40px;
    right: 40px;
  }
  .user-poster-canvas-main {
    box-sizing: border-box;
    padding: 70px 20px 20px;
    border-radius: 20px;
    background: #ffffff;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .user-poster-cover-box {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -100%);
      .user-poster-cover {
        height: 108px;
        width: 108px;
        position: relative;
        border-radius: 50%;
        overflow: hidden;
        .img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          position: relative;
        }
      }
      .user-poster-glory {
        width: 35px;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
    .user-poster-info {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 46px;
      .user-poster-name {
        font-family: PingFangSC-Medium;
        font-size: 32px;
        color: #283452;
        margin-bottom: 16px;
      }
      .user-poster-sign {
        width: 80%;
        font-family: PingFangSC-Regular;
        font-size: 22px;
        color: #bbc7ce;
        text-align: center;
      }
    }
    .user-poster-date {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      font-family: PingFangSC-Regular;
      margin-bottom: 36px;
      & > div {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        flex: 1;
        .active {
          font-family: DharmaTypeBebasKai;
          font-weight: 600;
          color: #283452;
          display: flex;
          align-items: center;
          .active-number {
            font-size: 38px;
          }
          .active-zi {
            font-size: 34px;
          }
        }
        .active-text {
          font-family: PingFangSC-Regular;
          font-size: 22px;
          color: rgba(40, 52, 82, 0.8);
          &.platform {
            width: 120%;
            text-align: center;
          }
        }
      }
    }
    .user-poster-qrcode {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding: 20px;
      background: #f7f8fd;
      border-radius: 10px;
      p {
        font-size: 24px;
        color: #6d7588;
        line-height: 36px;
        margin-right: 15px;
      }
      img {
        height: 130px;
        width: 130px;
      }
    }
  }
}
.qingsu-main {
  width: 600px;
  height: 1067px;
  margin: 88px 0 30px 0;
  border-radius: 10px;
  box-sizing: border-box;
}
.qingsu-content {
  position: relative;
  .qingsu-share-bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }
  .m-title {
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #21252d;
    text-align: justify;
  }
  .teacher-info {
    position: absolute;
    left: 40px;
    top: 72px;
    width: 520px;
    border-radius: 20px;
    padding: 51px 24px 0 24px;
    box-sizing: border-box;
    .base-info {
      display: flex;
      .base-left {
        width: 96px;
        height: 96px;
        position: relative;
        margin-right: 16px;
        .avatar {
          position: relative;
          border-radius: 50%;
          overflow: hidden;
          width: 100%;
          height: 100%;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .teacher-level {
          position: absolute;
          left: 10px;
          bottom: -8px;
          width: 75px;
          height: 29px;
        }
      }
      .base-right {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .m-name {
          font-size: 30px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #21252d;
        }
        .m-honor {
          font-size: 22px;
          margin-top: 4px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #6d7588;
          text-align: justify;
          line-height: 32px;
          // 显示2行所需的高度
          height: 64px;
          // 超出2行显示省略号（html2canvas不支持）
          overflow: hidden;
        }
      }
    }
    .block-info {
      background: #fff4f2;
      border-radius: 10px;
      height: 118px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 44px;
      .block {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        flex: 1;
        position: relative;
        .block-top {
          height: 27px;
          font-size: 30px;
          font-family: BebasKai;
          color: #21252d;
          line-height: 27px;
          white-space: nowrap;
          p {
            display: flex;
            align-items: center;
          }
        }
        .block-bottom {
          margin-top: 13px;
          font-size: 19px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #9da3ac;
          line-height: 19px;
          white-space: nowrap;
        }
        &:not(:last-child)::after {
          content: '';
          width: 1px;
          height: 19px;
          background-color: #eaeaea;
          position: absolute;
          bottom: 2px;
          right: 0;
        }
      }
      ::v-deep .bb-num {
        font-size: 30px;
        line-height: 27px;
      }
      ::v-deep .bb-text {
        margin: 0 2px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 16px;
      }
    }

    .tag-info {
      margin-top: 45px;
      ul {
        font-size: 0;
        white-space: nowrap;
        margin-top: 30px;
        display: flex;
        flex-wrap: wrap;
        height: 126px;
        overflow: hidden;
        li {
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff4f2;
          border-radius: 26px;
          width: 144px;
          height: 51px;
          margin-right: 20px;
          font-family: PingFangSC-Regular;
          font-size: 21px;
          color: #21252d;
          overflow: hidden;
          white-space: nowrap;
          margin-bottom: 24px;
          &:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }
  }
  .text-info {
    position: absolute;
    top: 749px;
    left: 64px;
    .base-text {
      width: 265px;
      margin-top: 16px;
      font-family: PingFangSC-Regular;
      font-size: 22px;
      color: #6d7588;
      text-align: justify;
      line-height: 38px;
      // 显示4行所需的高度
      height: 152px;
      overflow: hidden;
    }
  }
  .qrcode-wrp {
    position: absolute;
    right: 64px;
    bottom: 105px;
    width: 130px;
    height: 225px;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding-top: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .qrcode-inner {
      width: 110px;
      height: 110px;
      margin-bottom: 14px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .qrcode-tip {
      text-align: center;
      white-space: nowrap;
      padding-bottom: 14px;
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #6c798c;
      line-height: 19px;
      letter-spacing: 5px;
      border-bottom: 1px dashed #bcc2cf;
    }
    .logo-box {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 15px;
      width: 110px;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
